import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

export interface PaginationModel {
  pageIndex: number;
  pageSize: number;
  largePage?: number;
}

export const DEFAULT_PAGE_SETTINGS = {
  pageIndex: 1,
  pageSize: 5,
  largePage: 100,
};
@Component({
  selector: 'app-paginator',
  templateUrl: './app.paginator.html',
  styleUrls: ['./app.paginator.scss'],
})
export class PaginatorComponent {
  @Input() pageSizeOptions = [5, 10, 30, 50, 100];
  @Input() hasNextPage = false;
  @Input() defaultPageSize = this.pageSizeOptions[0];
  @Input() loading = false;
  @Input() pagination!: PaginationModel;

  @Output() paginationChanged: EventEmitter<PaginationModel> = new EventEmitter<PaginationModel>();

  localPagination: PaginationModel = {
    pageIndex: DEFAULT_PAGE_SETTINGS.pageIndex,
    pageSize: DEFAULT_PAGE_SETTINGS.pageSize,
  };

  pageLabel = `Записей на странице`;
  pageNumberText = `Страница`;

  constructor() {
    this.initLocalPagination();
    this.paginationChanged.emit(this.localPagination);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pagination']) {
      this.initLocalPagination();
    }
  }

  initLocalPagination() {
    if (this.pagination) {
      this.localPagination = {
        ...this.pagination,
      };
    }
  }

  toFirstPage() {
    if (this.localPagination.pageIndex > 1) {
      this.localPagination.pageIndex = 1;
      this.paginationChanged.emit(this.localPagination);
    }
  }

  toPrevPage() {
    if (this.localPagination.pageIndex > 1) {
      this.localPagination.pageIndex -= 1;
      this.paginationChanged.emit(this.localPagination);
    }
  }

  toNextPage() {
    if (this.hasNextPage && !this.loading) {
      this.localPagination.pageIndex += 1;
      this.paginationChanged.emit(this.localPagination);
    }
  }

  onPageSizeChanged($event: any) {
    this.localPagination.pageSize = $event.value;
    this.localPagination.pageIndex = 1;
    this.paginationChanged.emit(this.localPagination);
  }
}
